import { Controller } from 'stimulus'
import CheckoutController from './checkout_controller'
import { PlanData } from '../lib/types'
import { getLogger } from '@blueberry/observability'

const logger = getLogger('signup/form_plans_controller')

export default class FormPlansController extends Controller {
  declare planTarget: HTMLInputElement
  declare yearlyTargets: HTMLElement[]
  declare monthlyTargets: HTMLElement[]
  static targets = ['plan', 'yearly', 'monthly']

  declare checkoutOutlet: CheckoutController
  static outlets = ['checkout']

  async connect() {
    if (!this.checkoutOutlet) throw new Error('Missing checkout outlet')
    this.setInitialValues()

    const flow = this.checkoutOutlet.flowValue

    if (flow === 'd2c' && document.getElementById('payment-element')) {
      try {
        void this.checkoutOutlet.initializeStripe()
      } catch (error) {
        logger.error('Error initializing Stripe:', error)
      }
    }
  }

  setInitialValues() {
    if (!this.checkoutOutlet.signupData.plans) return
    const { plans } = this.checkoutOutlet.signupData

    this.planTarget.value = plans.plan
    this.showPlanTargets(plans.plan)
  }

  selectPlan(event: SelectPlanEvent) {
    const { plan } = event.params

    this.planTarget.value = plan
    this.showPlanTargets(plan)
  }

  showPlanTargets(plan: PlanData['plan']) {
    const targetsToShow =
      plan === 'yearly' ? this.yearlyTargets : this.monthlyTargets

    const targetsToHide =
      plan === 'yearly' ? this.monthlyTargets : this.yearlyTargets

    targetsToShow.forEach((target) => (target.hidden = false))
    targetsToHide.forEach((target) => (target.hidden = true))
  }
}

class SelectPlanEvent extends Event {
  declare params: {
    plan: PlanData['plan']
  }
}
